import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@mafc/trolly';

import * as S from './UpdateEmiratePopup.style';

const UpdateEmiratePopup: React.FC<{
  isOpen: boolean;
  onUpdate: () => void;
}> = ({ isOpen, onUpdate }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} showClose={false} height="auto">
      <S.PopupWrapper>
        <S.Message>{t('emiratePopup.message')}</S.Message>

        <S.ButtonRow>
          <S.UpdateButton
            variant="secondary"
            preventTextTransform
            onClick={onUpdate}
            data-testid="emirate-address-update"
          >
            {t('emiratePopup.updateAddress')}
          </S.UpdateButton>
        </S.ButtonRow>
      </S.PopupWrapper>
    </Modal>
  );
};

export default UpdateEmiratePopup;
